import React from "react";

const ListingEmptyState = ({ icon: Icon, title, hint, action }) => (
  <div className="mx-auto flex max-w-md flex-col items-center px-4 py-16 text-center">
    {Icon && (
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">
        <Icon className="h-7 w-7" />
      </div>
    )}
    <h3 className="text-base font-semibold text-slate-900">{title}</h3>
    {hint && <p className="mt-2 text-sm text-slate-500">{hint}</p>}
    {action}
  </div>
);

export default ListingEmptyState;
